import React from 'react'
import { Col, Label,Row } from 'reactstrap';
import { Dialog } from 'primereact/dialog';


export const ModalViewExamsQuoter = (props) => {

    const {
        modalViewExamsP, toggleModalViewExams, viewExamsProfile,
    } = props;

    return (
        
        <Dialog
            header="Exámenes del perfil"
            visible={modalViewExamsP}
            className="medium-dialog"
            modal
            onHide={toggleModalViewExams}
            footer={null}
        >

            {
                viewExamsProfile.length === 0 ? (

                    <div className="profile-empty">

                        <i className="fa fa-flask"></i>

                        <h6>Sin exámenes</h6>

                        <p>Este perfil no contiene exámenes.</p>

                    </div>

                ) : (

                    <div className="profile-exam-list">

                        {
                            viewExamsProfile.map((obj, index) => (

                                <div
                                    key={index}
                                    className="profile-exam-card"
                                >

                                    <div className="profile-exam-icon">

                                      <i className='icofont icofont-laboratory' style={{color: '#fff'}}></i>

                                    </div>

                                    <div className="profile-exam-info">

                                        <span className="profile-exam-number">
                                            EXAMEN {index + 1}
                                        </span>

                                        <h6>{obj.name}</h6>

                                    </div>

                                </div>

                            ))
                        }

                    </div>

                )
            }

        </Dialog>
    )
}
